export default function NotFound() {
  return (
    <main className="page-container">
      <h2>Página não encontrada</h2>
      <p>O conteúdo solicitado não está disponível ou foi movido.</p>
    </main>
  );
}
